__turbopack_context__.v({
  "articleSection": "Nn2vGa_articleSection",
  "richText": "Nn2vGa_richText",
  "singleImage": "Nn2vGa_singleImage",
});
